import { Star, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CTA, Eyebrow } from "@/components/ui-kit";
import { Seo } from "@/components/Seo";
import { IMAGES, LEARN_POINTS } from "@/lib/content";

export default function Book() {
  return (
    <div data-testid="book-page">
      <Seo
        title="The Book — The Shift"
        description="The Shift by Don Orr Jr. — become the Builder you were created to be. Read Chapter One free."
        path="/book"
      />
      {/* HERO */}
      <section className="relative bg-black noise pt-36 pb-24 lg:pt-44 lg:pb-32 overflow-hidden">
        <div className="relative z-10 max-w-[1240px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <Reveal className="order-2 lg:order-1">
            <Eyebrow>The Book</Eyebrow>
            <h1 className="font-display text-5xl lg:text-7xl text-white mt-7 tracking-tight leading-[1.02]">
              The Shift
            </h1>
            <p className="font-body text-lg text-white/60 mt-8 max-w-xl leading-relaxed">
              A book about becoming the Builder you were created to be. Not a hustle manual.
              Not a get-rich promise. A foundation for a life of purpose, integrity, and
              lasting impact.
            </p>
            <div className="flex items-center gap-4 mt-9">
              <div className="flex gap-1 text-[#D4AF37]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={15} fill="#D4AF37" strokeWidth={0} />
                ))}
              </div>
              <span className="font-body text-sm text-white/50">Loved by early readers</span>
            </div>
            <div className="flex flex-wrap gap-4 mt-10">
              <CTA to="/checkout" testId="book-buy-now" track="buy_the_shift" location="book_hero">Get Your Copy — $19</CTA>
              <CTA to="/preview" variant="ghost-light" arrow={false} track="read_chapter_one" location="book_hero">Read Chapter One</CTA>
            </div>
          </Reveal>
          <Reveal delay={120} className="order-1 lg:order-2">
            <div className="relative flex items-center justify-center min-h-[460px]">
              <img
                src={IMAGES.book}
                alt="The Shift"
                loading="eager"
                className="relative z-10 max-h-[600px] lg:max-h-[640px] w-auto animate-float-book"
                style={{
                  filter:
                    "drop-shadow(0 55px 45px rgba(0,0,0,0.55)) drop-shadow(0 20px 25px rgba(0,0,0,0.35))",
                }}
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* WHAT YOU'LL LEARN */}
      <section className="bg-white text-black py-28 lg:py-36">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
          <div className="max-w-2xl">
            <Eyebrow className="!text-[#B8952E]">Inside These Pages</Eyebrow>
            <h2 className="font-display text-4xl lg:text-5xl mt-6 tracking-tight">What You’ll Learn</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-14">
            {LEARN_POINTS.map((p, i) => (
              <Reveal key={p} delay={i * 50}>
                <div className="flex items-start gap-4 border border-[#e5e5e5] p-6 hover:border-[#D4AF37] transition-colors duration-300 h-full">
                  <Check size={20} className="text-[#D4AF37] mt-0.5 shrink-0" />
                  <span className="font-body text-black/80 leading-snug">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* READ CHAPTER ONE FREE */}
      <section className="bg-[#0a0a0a] noise py-24 lg:py-32">
        <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
          <Eyebrow>Read Chapter One — Free</Eyebrow>
          <h2 className="font-display text-3xl lg:text-4xl text-white mt-6 leading-tight">
            Not ready to buy? Start with Chapter One.
          </h2>
          <p className="font-body text-white/55 mt-5">
            Give us your name and email — we'll send the Advance Reader Preview straight to your inbox.
          </p>
          <div className="mt-9 flex justify-center">
            <CTA
              to="/preview"
              testId="book-read-chapter-one"
              track="read_chapter_one"
              location="book_chapter_section"
              className="!px-9 !py-4"
            >
              Send Me Chapter One
            </CTA>
          </div>
        </div>
      </section>

      {/* PROMISE */}
      <section className="bg-black noise py-28 lg:py-36">
        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
          <Reveal>
            <p className="font-display text-3xl lg:text-4xl text-white leading-snug">
              This isn’t a book you finish.<br />
              <span className="text-[#D4AF37] italic">It’s one you build from.</span>
            </p>
          </Reveal>
          <Reveal delay={150}>
            <div className="mt-11 flex justify-center">
              <CTA to="/checkout" track="buy_the_shift" location="book_final_cta" className="!px-11 !py-5">Get The Shift Today</CTA>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
